import { createAction } from '@reduxjs/toolkit';
import { PointsBurn } from 'types/pointsBurn';

export const setPointsBurnLuxeTiers = createAction<PointsBurn>('pointsBurnTiers/SET_POINTS_BURN_LUXE_TIERS');
export const fetchPointsBurnLuxeTiers = createAction('pointsBurnTiers/FETCH_POINTS_BURN_LUXE_TIERS');
export const clearPointsBurnLuxeTiers = createAction('pointsBurnTiers/CLEAR_POINTS_BURN_LUXE_TIERS');
